import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { injectIntl } from 'react-intl-next';
import { messages } from '../../messages';
import { RECENT_SEARCHES_SECTION_ID } from '../sections/recent-search-section';
/**
 * This component adds a title to the prequery recently viewed section if necessary.
 */
export var PreQueryRecentlyViewedTransformerWithIntl = function PreQueryRecentlyViewedTransformerWithIntl(_ref) {
  var intl = _ref.intl,
    preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  var newPreQueryItemsSections = preQueryItems.sections.map(function (section, i) {
    if (section.id === RECENT_SEARCHES_SECTION_ID || section.searchResults.length === 0) {
      return section;
    } else {
      var newSection = _objectSpread(_objectSpread({}, section), {}, {
        title: intl.formatMessage(messages.quick_find_recently_viewed)
      });
      return newSection;
    }
  });
  preQueryItems.sections = newPreQueryItemsSections;
  return children({
    preQueryItems: preQueryItems,
    postQueryItems: postQueryItems,
    productState: productState
  });
};
export var PreQueryRecentlyViewedTransformer = injectIntl(PreQueryRecentlyViewedTransformerWithIntl);